import { Link } from 'src/components/atoms/Link';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export type EmptyStateSize = 'small' | 'default';

export const Container = styled.div<{ size: EmptyStateSize }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${(props) => {
    switch (props.size) {
      case 'small':
        return '240px';
      case 'default':
        return '380px';
    }
  }};
`;

export const Title = styled.p`
  margin: 28px 0px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const Description = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  text-align: center;
  margin: 0;
  margin-bottom: 16px;
`;

export const ImageContainer = styled.div<{ $size: string }>`
  height: ${({ $size }) => $size};
  width: ${({ $size }) => $size};
`;

export const IntercomLink = styled(Link)`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  display: inline-block;
`;
